<template>
  <div class="sevenDaysContainer">
    <div class="publishTime" v-if="showTitle">
      <img src="../../assets/images/modules/daysforecasttime.png" alt="" />
      广州气象局{{ publishTime }}发布
    </div>
    <ul class="dateGroup">
      <li
        :class="
          item.isWeekend
            ? 'sunday '
            : '' + item.isTody
            ? 'today '
            : '' + item.isLastday
            ? 'lastday'
            : ''
        "
        v-for="(item, index) in dataGroup"
        :key="index"
      >
        <div class="time">
          <div class="date">{{ item.date }}</div>
          <div class="day">{{ item.day }}</div>
        </div>
        <div class="weather">
          <div class="day">
            <img
              v-if="item.dayImg"
              :src="require('../../assets/images/wicon/' + item.dayImg)"
              :title="item.dayImgTitle"
              alt=""
            />
            <div class="temperature">
              {{ item.dayTemperature }}
            </div>
            <div
              class="diff-wrap"
              :style="
                'border: 1px solid #ccc; visibility:' +
                (item.dayDiff < 1 ? 'hidden' : 'visible')
              "
            >
              <img
                v-if="item.isDayDown != undefined"
                :src="
                  require('../../assets/images/' +
                    (item.isDayDown ? 'down.png' : 'up.png'))
                "
                alt=""
              />
              {{ item.dayDiff }}
            </div>
          </div>
          <div class="night">
            <div
              class="diff-wrap"
              :style="
                'border: 1px solid #ccc; visibility:' +
                (item.nightDiff < 1 ? 'hidden' : 'visible')
              "
            >
              <img
                v-if="item.isNightDown != undefined"
                :src="
                  require('../../assets/images/' +
                    (item.isNightDown ? 'down.png' : 'up.png'))
                "
                alt=""
              />
              {{ item.nightDiff }}
            </div>
            <div class="temperature">
              {{ item.nightTemperature }}
            </div>
            <img
              v-if="item.nightImg"
              :src="require('../../assets/images/wicon/' + item.nightImg)"
              :title="item.nightImgTitle"
              alt=""
            />
          </div>
        </div>
      </li>
    </ul>
    <ul class="temperatureGroup">
      <li
        v-for="(item, index) in perHourDataGroup"
        :key="index"
        @mouseover="showInfo($event, item)"
        @mouseout="hiddenInfo"
      >
        <b
          v-if="item.temperature > -999"
          :style="'bottom:' + item.bottom + 'px;'"
          class="point"
        ></b>
        <b
          v-else
          :style="'bottom:' + item.bottom + 'px;'"
          class="point-null"
        ></b>
        <b v-html="item.html_rain"></b>
        <!-- {{item.html_rain}} -->
      </li>
    </ul>
    <div class="box" style="display: none"></div>
  </div>
</template>

<script>
import { home } from '../../api/index'
export default {
  data () {
    return {
      areaName: 'BCGZ',
      publishTime: '',
      AREA_CODE: {
        GDHX: ['huadu', '花都区'],
        GDCO: ['conghua', '从化区'],
        GDZC: ['zengcheng', '增城区'],
        GDPY: ['panyu', '番禺区'],
        GDHZ: ['haizhu', '海珠区'],
        GDLW: ['liwan', '荔湾区'],
        GDYX: ['yuexiu', '越秀区'],
        GDTH: ['tianhe', '天河区'],
        GDNS: ['nansha', '南沙区'],
        GDBY: ['baiyun', '白云区'],
        GDLG: ['huangpu', '黄埔区'],
        BCGZ: ['guagnzhou', '广州市'],
        花都区: ['huadu', 'GDHX'],
        从化区: ['conghua', 'GDCO'],
        增城区: ['zengcheng', 'GDZC'],
        番禺区: ['panyu', 'GDPY'],
        海珠区: ['haizhu', 'GDHZ'],
        荔湾区: ['liwan', 'GDLW'],
        越秀区: ['yuexiu', 'GDYX'],
        天河区: ['tianhe', 'GDTH'],
        南沙区: ['nansha', 'GDNS'],
        白云区: ['baiyun', 'GDBY'],
        黄埔区: ['huangpu', 'GDLG'],
        广州市: ['guagnzhou', 'BCGZ']
      },

      // 数据数组
      dataGroup: [],

      // 每个小时的体温、感温、降雨数据集合
      perHourDataGroup: []

    }
  },
  props: ['showTitle'],
  created () {
    this.init()
    console.log(this.showTitle)
  },

  methods: {
    init () {
      home.getGZ_weatherForecastByDays().then(data => {
        const forecastData = data[this.areaName]
        // console.log(forecastData)
        this.publishTime = forecastData.ptime
        this.BindingData_Forecast(forecastData)
        // console.log(forecastData.gift_rain)
        this.BindingData_Gift(forecastData.gift_t, forecastData.tig_t, forecastData.gift_rain, forecastData.ptimestemp)
      })
    },

    // 封装七天天气信息
    BindingData_Forecast (data) {
      const publishTime = new Date()
      publishTime.setTime(data.ptimestemp)
      const hour = publishTime.getHours()
      const end = data.datedec.length
      let day = 'f'
      let night = 'l'
      if (hour < 17 == true) {
        // todo: 交换样式
        this.$nextTick(() => {
          const dayNode = document.querySelectorAll('.weather .day')
          const nightNode = document.querySelectorAll('.weather .night')
          let i = 0
          while (i < dayNode.length) {
            dayNode[i].style.alignSelf = 'flex-start'
            nightNode[i].style.alignSelf = 'flex-end'
            i++
          }
        })
      } else {
        day = 'l'
        night = 'f'
        this.$nextTick(() => {
          const dayNode = document.querySelectorAll('.weather .day')
          const nightNode = document.querySelectorAll('.weather .night')
          let i = 0
          while (i < dayNode.length) {
            dayNode[i].style.alignSelf = 'flex-end'
            nightNode[i].style.alignSelf = 'flex-start'
            i++
          }
        })
        // todo：交换样式
      }
      for (let i = 0; i < end; i++) {
        let dayDiff = 0
        let nightDiff = 0
        let isDayDown = ''
        let isNightDown = ''
        // 对白天的差值判断
        if (data.maxt_diff[i] > 0) {
          dayDiff = data.maxt_diff[i]
          isDayDown = false
        } else if (data.maxt_diff[i] < 0) {
          dayDiff = 0 - data.maxt_diff[i]
          isDayDown = true
        } else {
          dayDiff = ''
        }

        // 对夜晚的差值判断
        if (data.mint_diff[i] > 0) {
          nightDiff = data.mint_diff[i]
          isNightDown = false
        } else if (data.mint_diff[i] < 0) {
          nightDiff = 0 - data.mint_diff[i]
          isNightDown = true
        } else {
          nightDiff = ''
        }

        // 封装数据结构
        const tempObj = {
          date: data.datedec[i],
          day: data.weekdays[i],
          isWeekend: data.weekend[i],
          isToday: i == 0,
          isLastday: i == (end - 1),

          // 白天天气
          dayDiff,
          isDayDown,
          dayTemperature: data.maxt[i] + '℃',
          dayImg: data['icons_' + day][i] + '.png',
          dayImgTitle: data['desc_' + day][i],

          // 晚上天气
          nightDiff,
          isNightDown,
          nightTemperature: data.mint[i] + '℃',
          nightImg: data['icons_' + night][i] + 'n.png',
          nightImgTitle: data['desc_' + night][i]
        }
        if (i == end - 1) {
          break
        }
        this.dataGroup.push(tempObj)
      }
      console.log(this.dataGroup)
    },

    // 获取一天24小时温度、体感温度、降雨
    BindingData_Gift (data, tigdata, rain, ptimestemp) {
      var val
      var tigval
      var pre = [0, data[1]]
      var next = new Array()
      var off = 6
      var html_rain
      var html_hour

      // 发布时间
      var ptime = new Date()
      ptime.setTime(ptimestemp)

      // 切换发布时间
      var hour = ptime.getHours()
      if (hour < 17 == true) {
        hour = 8
      } else {
        hour = 20
      }

      // 查找最低温度
      var mint = 100
      for (var i = 0; i < data.length; i++) {
        if (data[i] > -999 && data[i] < mint) {
          mint = data[i]
        }
      }
      mint = mint - 5

      // 是否有降雨
      var hasrain
      for (var i = 0; i < data.length; i++) {
        val = data[i]
        tigval = (tigdata[i] == -999.9 ? '--' : tigdata[i])
        // 判断当天是否有雨，测试方法强制个别时间有雨
        hasrain = rain[i] > 0
        html_rain = hasrain ? '<b class="point-rain"></b>' : ''
        html_hour = (hour > 9 ? hour + '' : '0' + hour)
        if (val >= -999) {
          pre = [i, val]
          next = [i, data[i + off]]
          const tempObj = {
            hour: html_hour,
            temperature: val,
            hasRain: hasrain,
            tigTemperature: tigval,
            bottom: (val - mint) * 2,
            html_rain
          }
          this.perHourDataGroup.push(tempObj)
          // html+='<li class="hour-li" title="'+html_hour+'时： '+val+'℃'+(hasrain?'，有雨':'')+'&#13;体感温度：'+tigval+'℃"><b style="bottom:'+((val-mint)*2)+'px;" class="point" data-t="'+val+'"></b>'+html_rain+'</li>';
        } else {
          val = pre[1] - (pre[1] - next[1]) * ((i - pre[0]) / off)
          const tempObj = {
            hour: html_hour,
            bottom: (val - mint) * 2,
            html_rain,
            hasRain: hasrain
          }
          this.perHourDataGroup.push(tempObj)
          // html+='<li class="hour-li" title="'+html_hour+'时"><b style="bottom:'+((val-mint)*2)+'px;" class="point-null"></b>'+html_rain+'</li>';
        }
        hour++
        if (hour == 24) {
          hour = 0
        }
      }
      console.log(this.perHourDataGroup)
    },

    // 鼠标放到对应的小时弹出信息框
    showInfo ($event, item) {
      const divNode = document.getElementsByClassName('box')[0]
      const sevenDaysContainerNode = document.getElementsByClassName('sevenDaysContainer')[0]
      // console.log(sevenDaysContainerNode.offsetLeft);
      // console.log(sevenDaysContainerNode.offsetTop);
      const left = sevenDaysContainerNode.offsetLeft
      const top = sevenDaysContainerNode.offsetTop
      divNode.innerHTML = item.hour + '时' + (item.temperature ? (': ' + item.temperature + '℃ ' + (item.hasRain ? '有雨' : '') + '<br>' + '体感温度:' + item.tigTemperature + '℃') : '')
      divNode.style.left = $event.pageX - left + 20 + 'px'
      divNode.style.top = $event.pageY - top + 20 + 'px'
      divNode.style.display = 'block'
    },

    // 隐藏信息框
    hiddenInfo () {
      const divNode = document.getElementsByClassName('box')[0]
      divNode.style.display = 'none'
    }
  }
}
</script>

<style lang="less">
.sevenDaysContainer {
  position: relative;
  .publishTime {
    display: flex;
    height: 48px;
    align-items: center;
    position: absolute;
    left: 140px;
    top: -52px;
    border-left: 1px solid #ccc;
    color: white;
  }
  .dateGroup {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    margin-bottom: 80px;
    .sunday {
      color: red;
    }
    li {
      display: flex;
      flex-direction: column;
      flex: 1;
      justify-content: space-between;
      align-items: center;
      margin-right: 5px;
      .time {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        padding: 5px 10px;
        border-bottom: 3px solid #28a1e5;
      }
      .weather {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        margin-top: 10px;
        color: black;
        img {
          width: 50px;
          height: 50px;
        }
        .day,
        .night {
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 10px;
          .temperature {
            margin-top: 10px;
          }
          .diff-wrap {
            display: flex;
            justify-content: space-evenly;
            align-items: center;
            width: 31px;
            height: 16px;
            margin-top: 10px;
            border-radius: 12px;
            img {
              width: 13px;
              height: 17px;
            }
          }
        }
        .day {
          align-self: flex-start;
        }

        .night {
          align-self: flex-end;
        }
      }
    }
  }

  .temperatureGroup {
    display: flex;
    align-items: flex-start;
    position: absolute;
    top: 80px;
    width: 100%;
    height: 280px;
    li:hover {
      background-color: #28a1e5;
      opacity: 0.3;
    }
    li {
      position: relative;
      height: 100%;
      flex: 1;
      cursor: pointer;
      .point {
        z-index: 1;
        width: 4px;
        height: 4px;
        border: 0px solid #28a1e5;
        background-color: #28a1e5;
        display: block;
        position: absolute;
        border-radius: 2px;
      }

      .point-null {
        z-index: 1;
        position: absolute;
        width: 2px;
        height: 2px;
        background-color: #aaa;
      }
    }
  }

  .box {
    display: block;
    position: absolute;
    padding: 10px;
    border: 1px solid black;
    background-color: #fff;
    font-size: 12px;
    z-index: 2;
  }
}
</style>
